import React, { FC } from 'react';
import {
  Accordion,
  accordionItemBuilder,
  Text,
  TextButton,
  Box,
} from '@wix/design-system';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../../CommunityNavSubHeader.dataHooks';
import {
  COMMUNITY_NAV_DROPDOWN_OPTIONS,
  DROPDOWN_IDS,
  DropdownId,
} from '../../navSubHeaderUtils';
import s from './CommunityNavModalMainScreen.module.scss';

const CommunityNavModalMainScreen = () => {
  const { t } = useTranslation();

  return (
    <Box display="block" margin="0 -24px" className={s.accordionContainer}>
      <Accordion
        dataHook={communityNavSubHeaderDataHooks.mobileContent()}
        horizontalPadding="none"
        skin="light"
        hideShadow
        items={DROPDOWN_IDS.map((id: DropdownId) =>
          accordionItemBuilder({
            title: (
              <Box display="block" paddingLeft="SP4">
                <Text size="medium" weight="thin">
                  {t(`marketplace.community-nav-sub-header.${id}`)}
                </Text>
              </Box>
            ),
            children: (
              <CategoryLinks options={COMMUNITY_NAV_DROPDOWN_OPTIONS[id]} />
            ),
            buttonType: 'node',
            showLabel: 'always',
            collapseLabel: <ChevronUpIcon />,
            expandLabel: <ChevronDownIcon />,
          }),
        )}
      />
    </Box>
  );
};

export default CommunityNavModalMainScreen;

const ChevronUpIcon = () => (
  // TODO: These may need BI
  <Box paddingRight="SP4">
    <TextButton>
      <ChevronUp />
    </TextButton>
  </Box>
);

const ChevronDownIcon = () => (
  <Box paddingRight="SP4">
    <TextButton>
      <ChevronDown />
    </TextButton>
  </Box>
);

interface CommunityNavLinkProps {
  labelKey: string;
  hrefKey: string;
}

const CommunityNavLink: FC<CommunityNavLinkProps> = ({ labelKey, hrefKey }) => {
  const { t } = useTranslation();
  return (
    <div role="listitem">
      <Box display="block" padding="SP2 0 SP2 SP8">
        <TextButton
          as="a"
          skin="dark"
          weight="thin"
          size="medium"
          href={t(hrefKey)}
          target="_blank"
          rel="noopener noreferrer"
          className={s.categoryLink}
        >
          <Box display="block">
            <Text size="medium" weight="thin">
              {t(labelKey)}
            </Text>
          </Box>
        </TextButton>
      </Box>
    </div>
  );
};

interface CategoryLinksProps {
  options: { labelKey: string; hrefKey: string }[];
}

const CategoryLinks: FC<CategoryLinksProps> = ({ options }) => (
  <Box backgroundColor="#FFF" direction="vertical">
    {options.map((option) => (
      <CommunityNavLink
        key={option.hrefKey}
        labelKey={option.labelKey}
        hrefKey={option.hrefKey}
      />
    ))}
  </Box>
);
